export const phoneRegExp = /^(\([0-9]{3}\)|[0-9]{3}-)[0-9]{3}-[0-9]{4}|(\([0-9]{3}\)|[0-9]{3})[0-9]{3}[0-9]{4}$/;
export const nameRegExp = /^[ '\-A-Za-z]*$/;
export const specimenLabelRegExp = /^[a-zA-Z]{4}-[0-9]{3}-[0-9]*$/g;
